<ngb-accordion #a="ngbAccordion" activeIds="custom-panel" class = "mr-3">
  <ngb-panel id="custom-panel">
    <ng-template ngbPanelHeader let-opened="opened">
      <div class="d-flex align-items-center justify-content-between">
        <h5 class="m-0">{{title}}</h5>
        <button ngbPanelToggle class="btn btn-link p-0" translate>accordion.view_button</button>
      </div>
    </ng-template>
    <ng-template ngbPanelContent>

      <div class="table-responsive">

      <table class="table table-striped">
        <thead>
        <tr>
          <th>#</th>
         <th *ngFor="let field of fields" scope="col" class = "text-center" translate>{{field}}</th>
         <th translate>table.fields.type</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let items of data" class = "text-center">
        <tr *ngFor="let items of data; index as i" class = "text-center">

          <th scope="row">{{ i + 1 }}</th>

          <td *ngFor="let item of items">
             {{item}}
          </td>
          
        </tr>
        </tbody>
      </table>

    </div>
  
    </ng-template>
  </ngb-panel>
</ngb-accordion>